import React,{useState,useRef,useEffect} from 'react'
import BlogHeader  from './BlogHeader.js';
import Navbar from '../components/Navbar.js'
import Footer from '../components/Footer.js'
import { Helmet } from 'react-helmet-async'



function ERA2025() {
    const [name, setName] = useState('');
    const [firmName, setFirmName] = useState('');
    const [email,setEmail] = useState('');
    const [jurisdiction,setJurisdiction] = useState([]);
    const [practiceArea,setPracticeArea] = useState([]);
    const [toast, setToast] = useState({ message: '', type: '', visible: false })
    const [jurisdictionOpen, setJurisdictionOpen] = useState(false);
    const [practiceOpen, setPracticeOpen] = useState(false);
    const leadFormRef = useRef(null);
    const jurisdictionRef = useRef(null);
    const practiceRef = useRef(null);

    const showToast = (message, type) => {
          setToast({ message, type, visible: true })
          setTimeout(() => setToast({ message: '', type: '', visible: false }), 5000)
        }
    
      const logRequest = async () => {
          if(!name.trim()){
            showToast("Please enter your full name.", "error")
            return
          }
          if(!firmName.trim()){
            showToast("Please enter your firm name.", "error")
            return
          }
          if(!email.trim()){
            showToast("Please enter your work email address.", "error")
            return
          }
          if(jurisdiction.length === 0){
            showToast("Please select at least one jurisdiction.", "error")
            return
          }
          if(practiceArea.length === 0){
            showToast("Please select at least one practice area.", "error")
            return
          }
    
          try {
            const response = await fetch('https://cac3vl23dkklu4rdxwki5yooxa0upfuq.lambda-url.eu-west-2.on.aws/capture-lead', {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                'name': name,
                'firm_name': firmName,
                'work_email': email,
                'primary_jurisdiction': jurisdiction,
                'primary_practice_area': practiceArea
              })
            });
    
            if(response.status === 422){
              showToast("Please provide a valid work email address. Personal email addresses — Gmail, Hotmail, Yahoo and similar — are not accepted.", "error")
            } else if(response.status === 409){
              showToast("This email address is already registered on the LexiTrove waitlist. We will be in touch ahead of the pilot cohort go-live.", "error")
            } else if(!response.ok){
              const error = await response.text()
              console.log(error)
              showToast("Your submission could not be processed. Please try again.", "error")
            } else {
              showToast("Expression of interest received. A member of the LexiTrove team will be in touch within 24 hours to schedule an initial consultation.", "success")
              setName('')
              setFirmName('')
              setEmail('')
              setJurisdiction([])
              setPracticeArea([])
              setJurisdictionOpen(false)
              setPracticeOpen(false)
            }
          } catch(err) {
            console.error("Network error:", err)
            showToast("A network error occurred. Please check your connection and try again.", "error")
          }
        }
    
      const scrollToForm = () => {
        leadFormRef.current?.scrollIntoView({ behavior: 'smooth' });
      };
    
      useEffect(() => {
        const handleClickOutside = (e) => {
          if(jurisdictionRef.current && !jurisdictionRef.current.contains(e.target)){
            setJurisdictionOpen(false)
          }
          if(practiceRef.current && !practiceRef.current.contains(e.target)){
            setPracticeOpen(false)
          }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
       }, [])

  return (
    <div>
        <Helmet>
          <title>Beyond the April Horizon: What ERA 2025 Demands of Employment Practitioners Right Now | LexiTrove</title>
          <meta name='description' content="Prepare for the landmark ERA 2025 changes hitting UK workplaces by April. Discover what employment practitioners must do right now to ensure full compliance."/>
          <link rel='canonical' href='https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now'/>
          <meta property="og:site_name" content="LexiTrove" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Beyond the April Horizon: What ERA 2025 Demands of Employment Practitioners Right Now"/>
          <meta property="og:url" content="https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now" />
          <meta property="og:description" content= "Prepare for the landmark ERA 2025 changes hitting UK workplaces by April. Discover what employment practitioners must do right now to ensure full compliance."/>
          <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "name": "Beyond the April Horizon: What ERA 2025 Demands of Employment Practitioners Right Now | LexiTrove",
            "headline": "Beyond the April Horizon: What ERA 2025 Demands of Employment Practitioners Right Now | LexiTrove",
            "description":"Prepare for the landmark ERA 2025 changes hitting UK workplaces by April. Discover what employment practitioners must do right now to ensure full compliance.",
            "inLanguage":"en-GB",
            "isFamilyFriendly":	"true",
            "author": [{
                "@type": "Person",
                "name": "Rohit Kumar"
              }],
            "url":"https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now",
            "datePublished": "2026-07-14T08:00:00+08:00",
            "dateModified": "2026-07-14T00:00:00+08:00",
            "keywords": ["Employment Rights Act 2025","ERA 2025 compliance","April 2026 employment law changes UK","Employment practitioners checklist ERA","Day-one family leave rights UK","Statutory Sick Pay reforms April 2026","Collective redundancy protective award double","Fair Work Agency enforcement timeline","Employment Solicitor guide to Employment Rights Act changes","UK employment tribunal limit extensions"]
          })}
          </script>
        </Helmet>
        <div className='home'>
        <Navbar/>
        <div className='blog'>
        <BlogHeader 
        BlogStamp={<>13<sup>th</sup> July, 2026</>} 
        BlogTitle="Beyond the April Horizon: What ERA 2025 Demands of Employment Practitioners Right Now" 
        BlogMinutes="9 min read"
        />
        <br/>
        <p>
            If you feel like you've barely caught your breath after the April 2026 rollout of Statutory Sick Pay reforms and Day 1 paternity rights, you're not alone. Welcome to July 2026.
            <br/><br/>
            The Employment Rights Act 2025 isn't a single legal change. It's a sequence of legal changes arriving on different dates, at different speeds, across different jurisdictions. That's the part most coverage misses - and it's the part that actually determines what you tell a client this month.
            <br/><br/>
            Here's what's coming next from a practitioner's perspective, and why the decisions your clients make in July matter more than they realise. 
        </p>
        <br/>
        <h3>The July Conundrum: Why Current Hires Dictate January 2027 Success</h3><br/>
        <p>
        It's easy to look at the January 2027 deadline for the new unfair dismissal framework and think, "We have time." Mathematically, the clock is already ticking.
        <br/><br/>
        From 1<sup>st</sup> January 2027, the qualifying period for ordinary unfair dismissal protection drops from two years to six months - and it applies to employees already in service at that date.
        <br/><br/>
        The immediate impact: anyone your clients hire during this July will cross the six-month milestone right as the new rules come into force.
        <br/><br/>
        So what does that actually change? Employers hiring this summer don't have until January 2027 to start thinking about unfair dismissal risk. By the time the reforms take effect, many of those employees will already have six months' service. Induction frameworks, probationary reviews, and performance management need to be tightened this quarter, not reviewed in December when the reform is already live and the hire is already protected.
        </p>
        <br/>
        <div className='Waitlist-Advert'>
            <h4>
            LexiTrove is inviting employment law firms & practitioners to help shape it.<br/>
            Founding cohort members get direct input into the product roadmap - your jurisdiction, your practice area, your workflow.
            </h4><br/>
            <button className='Waitlist-Advert-Button' onClick={scrollToForm}>Join Founding Cohort</button>
        </div>
        <br/>
        <h3>The End of the Compensation Cap</h3><br/>
        <p>
        Compounding the shorter qualifying period is the complete removal of the statutory cap on unfair dismissal compensatory awards - currently the lower of £123,543 or 52 weeks' gross pay.
        <br/><br/>
        The median tribunal award has historically stayed modest, so it's tempting to read this as a change that mostly matters for outlier cases. It doesn't. The cap didn't just limit compensation - it anchored settlement strategy. Every negotiation you've run for the past two decades has had an implicit ceiling both sides could price against. Remove the anchor, and the negotiation itself changes, not just the worst-case number.
        <br/><br/>
        There's a second-order effect worth flagging to clients directly: previously, high earners routinely tacked on discrimination or whistleblowing claims onto a straightforward unfair dismissal claim, purely to get around the cap. Once the cap disappears, that incentive disappears with it - expect a shift back toward pure, high-value unfair dismissal claims, where procedural fairness isn't a compliance nicety but the entire defence.
        </p>
        <br/>
        <h3>October 2026 Is Closer Than It Looks</h3><br/>
        <p>
            Before January's shake-up, October 2026 brings two changes that need proactive planning now - one of them more settled than the other, in a way that's itself worth understanding.
            <br/><br/>
            The six-month tribunal window is now confirmed, with one jurisdictional catch. The standard limitation period for most employment tribunal claims extends from three months to six. This is no longer a direction of travel - <a href='https://hansard.parliament.uk/Lords/2026-06-23/debates/7586D54C-9E17-45D7-BB1A-36EE9546DBB2/EmploymentTribunal(ExtensionOfTimeLimits)(MiscellaneousAmendmentsAndTransitionalProvisions)Regulations2026' target='/'>both Houses of Parliament approved the relevant regulations on 23 June 2026,</a> and the change is set to take effect on 1 October 2026 for claims where the relevant date falls on or after that day.
            <br/><br/>
            Here's the catch a lot of firms haven't caught yet: breach of contract claims in Scotland are on a different clock. The England & Wales extension for breach of contract claims runs through a separate order that doesn't extend north of the border - equivalent <a href='https://hansard.parliament.uk/Lords/2026-06-23/debates/7586D54C-9E17-45D7-BB1A-36EE9546DBB2/EmploymentTribunal(ExtensionOfTimeLimits)(MiscellaneousAmendmentsAndTransitionalProvisions)Regulations2026' target='/'>Scottish provision isn't expected until mid-November 2026</a>. For roughly six weeks, the same underlying facts could produce a three-month limit in Scotland and a six-month limit in England and Wales. If you're advising across UK jurisdictions and haven't built that gap into your file diary yet, this is the moment to do it - not in October, when the first affected claim is already close to its old deadline.
            <br/><br/>
            The "all reasonable steps" harassment standard is where the real risk of complacency sits. The existing duty to take "reasonable steps" to prevent sexual harassment becomes a stricter duty to take all reasonable steps, alongside new direct liability for harassment of staff by third parties. The trap isn't having no policy - most employers updated theirs after the last round of harassment law changes and assume they're covered. The real risk is assuming last year's policy still satisfies this year's standard. It won't, and the gap between "we have a policy" and "we meet the current test" is exactly where a claim gets made.
        </p>
        <br/>
        <h3>Keeping Advice Current Between Royal Assent and Commencement</h3><br/>
        <p>
            None of the reforms above happened on the date ERA 2025 received Royal Assent. <a href='https://www.gov.uk/government/publications/implementing-the-plan-to-make-work-pay-and-employment-rights-act/plan-to-make-work-pay-and-employment-rights-act-timeline-update' target='/'>Each one arrives on its own separate commencement date,</a>confirmed at its own pace, sometimes revised after the fact - the ET limitation date itself moved from "no earlier than October 2026" to a confirmed 1 October only recently. Layer in the Scotland gap, the ongoing consultations on NDAs and zero-hours contracts, and the difference between what the Act says on paper and what's actually in force on any given day, and a genuinely uncomfortable question emerges:
            <br/><br/>
            Clients assume the advice they're receiving reflects the law as it stands today. That assumption gets harder to guarantee the moment implementation is staggered across multiple dates, multiple consultations, and multiple jurisdictions running on different clocks. The work of keeping pace with that - tracking commencement regulations, consultation outcomes, and jurisdiction-specific dates like the Scotland lag above - isn't billable. But getting it wrong shows up directly in the quality of the advice a client receives.
        </p>
        <br/>
        <h3>Join the Founding Cohort</h3><br/>
        
        <div className='Advert-section'>
        <div className='Advert-hero'>
          <p>
            Between now and January 2027, employment lawyers will need to track commencement regulations, consultation outcomes, updated Acas guidance, and jurisdiction-specific implementation dates. Missing any of it can directly affect the advice a client receives.
            <br/><br/>
            LexiTrove is being built as the one-stop platform for UK Employment Law practitioners - from matter intake to Tribunal judgment. Firms and practitioners are invited to help shape it as part of our founding cohort.
            <br/><br/>
        </p>
        </div>
        <div className='Lead-Form' ref={leadFormRef}>
          <form>
            <label>Name</label><br/>
            <input 
              type='text' 
              value={name} 
              onChange={(e) => setName(e.target.value)}
            /><br/>

            <label>Firm Name</label><br/>
            <input 
              type='text' 
              value={firmName} 
              onChange={(e) => setFirmName(e.target.value)}
            /><br/>

            <label>Work Email</label><br/>
            <input 
              type='text' 
              value={email} 
              onChange={(e) => setEmail(e.target.value)}
            /><br/>

            <label>Primary Jurisdiction</label><br/>
            <div className='dropdown-wrapper' ref={jurisdictionRef}>
              <div 
                className='dropdown-trigger'
                onClick={(e) => {
                  e.stopPropagation()
                  setJurisdictionOpen(!jurisdictionOpen)
                }}
              >
                {jurisdiction.length > 0 ? jurisdiction.join(', ') : 'Select jurisdiction'}
              </div>
              {jurisdictionOpen && (
                <div className='dropdown-options'>
                  {['England', 'Wales', 'Scotland', 'Northern Ireland'].map(option => (
                    <div 
                      key={option} 
                      className='checkbox-row'
                      onClick={(e) => {
                        e.stopPropagation()
                        if(jurisdiction.includes(option)){
                          setJurisdiction(jurisdiction.filter(j => j !== option))
                        } else {
                          setJurisdiction([...jurisdiction, option])
                        }
                      }}
                    >
                      <input 
                        type='checkbox'
                        checked={jurisdiction.includes(option)}
                        onChange={() => {}}
                        readOnly
                      />
                      <span>{option}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          
            <label>Primary Practice Area</label><br/>
            <div className='dropdown-wrapper' ref={practiceRef}>
              <div 
                className='dropdown-trigger'
                onClick={(e) => {
                  e.stopPropagation()
                  setPracticeOpen(!practiceOpen)
                }}
              >
                {practiceArea.length > 0 ? practiceArea.join(', ') : 'Select practice area'}
              </div>
              {practiceOpen && (
                <div className='dropdown-options'>
                  {['Contentious', 'Non-Contentious', 'Merger & Acquisition'].map(option => (
                    <div 
                      key={option} 
                      className='checkbox-row'
                      onClick={(e) => {
                        e.stopPropagation()
                        if(practiceArea.includes(option)){
                          setPracticeArea(practiceArea.filter(p => p !== option))
                        } else {
                          setPracticeArea([...practiceArea, option])
                        }
                      }}
                    >
                      <input 
                        type='checkbox'
                        checked={practiceArea.includes(option)}
                        onChange={() => {}}
                        readOnly
                      />
                      <span>{option}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          
            <button 
              type="button" 
              onClick={() => logRequest()}
              className='cta-button'
            >
              Join Founding Cohort
            </button>
          </form>
        </div>
        </div>
        {toast.visible && (
          <>
            {/* Overlay */}
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.3)',
              zIndex: 999
            }}/>

            {/* Modal */}
            <div style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#F4F1EA',
              border: `1px solid ${toast.type === 'success' ? '#C96A4A' : '#1A1A1A'}`,
              borderTop: `3px solid ${toast.type === 'success' ? '#C96A4A' : '#1A1A1A'}`,
              padding: '2rem',
              fontFamily: "'Jost', monospace",
              fontSize: '0.75rem',
              color: toast.type === 'success' ? '#C96A4A' : '#1A1A1A',
              maxWidth: '400px',
              width: '90%',
              zIndex: 1000,
              lineHeight: '1.8',
              textAlign: 'center'
            }}>
              <p style={{marginBottom: '1.5rem'}}>{toast.message}</p>
              <button 
                onClick={() => setToast({ message: '', type: '', visible: false })}
                style={{
                  fontFamily: "'Jost', monospace",
                  fontSize: '0.75rem',
                  backgroundColor: toast.type === 'success' ? '#C96A4A' : '#1A1A1A',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 20px',
                  cursor: 'pointer',
                  letterSpacing: '0.06em',
                  textTransform: 'uppercase'
                }}
              >
                Close
              </button>
            </div>
          </>
        )}
        </div>
        <Footer/>   
    </div>
    </div>
  )
}

export default ERA2025